import React, { Suspense } from 'react';
import './ToJoin.sass';
import Button from '../button/Button';
import Title from '../title/Title';
import SmallText from '../smallText/Smalltext';
import i18n from '../../../i18n';
import check from './../../../resources/icons/check.svg';
import Config from '../../../base/config/Config';
import DataArray from '../../../base/config/DataArray';
import LazyLoad from 'react-lazyload';

function ToJoin({medium}) {
    var dataArray = DataArray.details;

    return (
        <Suspense fallback={null}>
            <div className="toJoinArea">
                <div className="toJoinMessageArea">
                    <Title size="Big" type="Primary" text={i18n.t('There’s a different lifestyle for social media managers before and after Swonkie. What’s yours?')} />
                </div>
                <div className="toJoinButtonArea">
                    <a href={`${Config.appHost}register?utm_source=website&utm_medium=${medium}&utm_campaign=cta-1`}> <Button size="Big" type="Tertiary" text={i18n.t('I want to improve my performance')} /> </a>
                </div>
                <div className="toJointextArea">
                    {dataArray.map((category, key) => {
                        return (
                            <div className="toJoinText" key={key}>
                                <LazyLoad offset={200} height={10}>
                                    <img src={check} alt="check" />
                                </LazyLoad>
                                <SmallText size="Big" type="Primary" font="OpenSans" text={category.text} />
                            </div>
                        );
                    })}
                </div>
            </div>
        </Suspense>
    );
}

export default ToJoin;
